import { render, staticRenderFns } from "./CambiarPassword.vue?vue&type=template&id=3d8754d6&"
import script from "./CambiarPassword.vue?vue&type=script&lang=js&"
export * from "./CambiarPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports